function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var _require = require('./helpers'),
  transactionIndexInBlock = _require.transactionIndexInBlock;
function restoreTransaction(app, serialized) {
  var Transaction = require('../../../lib/saito/transaction')["default"];
  var tx = new Transaction();
  if (typeof tx.deserialize_from_web === 'function') {
    tx.deserialize_from_web(app, serialized);
  }
  return tx;
}
var Refunds = /*#__PURE__*/function () {
  function Refunds(mod) {
    _classCallCheck(this, Refunds);
    this.mod = mod;
  }
  return _createClass(Refunds, [{
    key: "app",
    get: function get() {
      return this.mod.app;
    }
  }, {
    key: "db",
    get: function get() {
      return this.mod.warehouse.db;
    }
  }, {
    key: "retryMs",
    value: function retryMs() {
      var configured = Number(this.mod.refund_retry_ms);
      return Number.isFinite(configured) && configured >= 0 ? configured : 6 * 60 * 60 * 1000;
    }
  }, {
    key: "deadline",
    value: function deadline(row) {
      return Number((row === null || row === void 0 ? void 0 : row.created_at) || 0) + this.retryMs();
    }
  }, {
    key: "expired",
    value: function expired(row) {
      var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
      return this.deadline(row) <= now;
    }
  }, {
    key: "identityFromOrder",
    value: function identityFromOrder(order) {
      var _order$payment_output;
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$refund_public_ke = _ref.refund_public_key,
        refund_public_key = _ref$refund_public_ke === void 0 ? '' : _ref$refund_public_ke,
        _ref$reason = _ref.reason,
        reason = _ref$reason === void 0 ? '' : _ref$reason;
      return {
        payment_tx_sig: String((order === null || order === void 0 ? void 0 : order.payment_tx_sig) || '').trim(),
        payment_output_index: Number((_order$payment_output = order === null || order === void 0 ? void 0 : order.payment_output_index) !== null && _order$payment_output !== void 0 ? _order$payment_output : 0),
        block_hash_received: String((order === null || order === void 0 ? void 0 : order.block_hash_received) || ''),
        block_id_received: Number(order === null || order === void 0 ? void 0 : order.block_id_received) || 0,
        order_tx_sig: String((order === null || order === void 0 ? void 0 : order.order_tx_sig) || (order === null || order === void 0 ? void 0 : order.signature) || ''),
        order_id: Number(order === null || order === void 0 ? void 0 : order.id) || 0,
        buyer: String((order === null || order === void 0 ? void 0 : order.buyer) || ''),
        refund_publickey: String(refund_public_key || (order === null || order === void 0 ? void 0 : order.buyer) || ''),
        reason: String(reason || ''),
        utxo_slip: String((order === null || order === void 0 ? void 0 : order.utxo_slip) || ''),
        access_script: String((order === null || order === void 0 ? void 0 : order.access_script) || ''),
        payment_amount: Number(order === null || order === void 0 ? void 0 : order.payment_amount) || 0
      };
    }
  }, {
    key: "issue",
    value: function () {
      var _issue = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(order) {
        var options,
          identity,
          row,
          _args = arguments,
          _t,
          _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              identity = this.identityFromOrder(order, options);
              if (!(!identity.payment_tx_sig || !identity.block_hash_received)) {
                _context.n = 5;
                break;
              }
              console.error('Store: refund was not created because its payment identity is incomplete', {
                payment_tx_sig: identity.payment_tx_sig,
                block_hash_received: identity.block_hash_received,
                reason: identity.reason
              });
              if (!identity.order_id) {
                _context.n = 4;
                break;
              }
              _context.p = 1;
              _context.n = 2;
              return this.db.updateOrder(identity.order_id, {
                status: 'unfulfillable'
              });
            case 2:
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('Store: order could not be marked for manual investigation', {
                order_id: identity.order_id,
                error: (_t === null || _t === void 0 ? void 0 : _t.message) || String(_t)
              });
            case 4:
              return _context.a(2, {
                broadcast: false,
                reason: 'incomplete-payment-identity'
              });
            case 5:
              _context.p = 5;
              _context.n = 6;
              return this.db.claimRefundIntent(identity);
            case 6:
              row = _context.v;
              _context.n = 8;
              break;
            case 7:
              _context.p = 7;
              _t2 = _context.v;
              console.error('Store: refund intent was not saved', {
                payment_tx_sig: identity.payment_tx_sig,
                payment_output_index: identity.payment_output_index,
                block_hash_received: identity.block_hash_received,
                error: (_t2 === null || _t2 === void 0 ? void 0 : _t2.message) || String(_t2)
              });
              return _context.a(2, {
                broadcast: false,
                reason: 'intent-not-saved',
                error: _t2
              });
            case 8:
              return _context.a(2, this["continue"](row, order));
          }
        }, _callee, this, [[5, 7], [1, 3]]);
      }));
      function issue(_x) {
        return _issue.apply(this, arguments);
      }
      return issue;
    }()
  }, {
    key: "resume",
    value: function () {
      var _resume = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var rows, _iterator, _step, row, _t3, _t4, _t5;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.n = 1;
              return this.db.returnRefundsNeedingAttention();
            case 1:
              _t3 = _context2.v;
              if (_t3) {
                _context2.n = 2;
                break;
              }
              _t3 = [];
            case 2:
              rows = _t3;
              _iterator = _createForOfIteratorHelper(rows);
              _context2.p = 3;
              _iterator.s();
            case 4:
              if ((_step = _iterator.n()).done) {
                _context2.n = 9;
                break;
              }
              row = _step.value;
              _context2.p = 5;
              _context2.n = 6;
              return this["continue"](row);
            case 6:
              _context2.n = 8;
              break;
            case 7:
              _context2.p = 7;
              _t4 = _context2.v;
              console.error('Store: refund resume failed', {
                refund_id: row === null || row === void 0 ? void 0 : row.id,
                refund_tx_sig: (row === null || row === void 0 ? void 0 : row.refund_tx_sig) || '',
                error: (_t4 === null || _t4 === void 0 ? void 0 : _t4.message) || String(_t4)
              });
            case 8:
              _context2.n = 4;
              break;
            case 9:
              _context2.n = 11;
              break;
            case 10:
              _context2.p = 10;
              _t5 = _context2.v;
              _iterator.e(_t5);
            case 11:
              _context2.p = 11;
              _iterator.f();
              return _context2.f(11);
            case 12:
              return _context2.a(2);
          }
        }, _callee2, this, [[5, 7], [3, 10, 11, 12]]);
      }));
      function resume() {
        return _resume.apply(this, arguments);
      }
      return resume;
    }()
  }, {
    key: "continue",
    value: function () {
      var _continue2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        var order,
          saved,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              order = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : null;
              if (row) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, {
                broadcast: false,
                reason: 'missing-refund'
              });
            case 1:
              if (!(row.refund_status === 'needs_manual')) {
                _context3.n = 2;
                break;
              }
              return _context3.a(2, {
                broadcast: false,
                reason: 'needs-manual',
                refund: row
              });
            case 2:
              if (!(row.refund_status === 'confirmed' && Number(row.longest_chain_refunded) === 1)) {
                _context3.n = 3;
                break;
              }
              return _context3.a(2, {
                broadcast: false,
                reason: 'confirmed',
                refund: row
              });
            case 3:
              if (!this.expired(row)) {
                _context3.n = 4;
                break;
              }
              return _context3.a(2, this.escalate(row, 'refund retry window expired'));
            case 4:
              if (row.refund_tx_sig) {
                _context3.n = 7;
                break;
              }
              _context3.n = 5;
              return this.signOnce(row, order);
            case 5:
              saved = _context3.v;
              if (saved !== null && saved !== void 0 && saved.refund_tx_sig) {
                _context3.n = 6;
                break;
              }
              return _context3.a(2, saved || {
                broadcast: false,
                reason: 'not-signed',
                refund: row
              });
            case 6:
              row = saved;
            case 7:
              if (!(row.refund_status === 'needs_manual')) {
                _context3.n = 8;
                break;
              }
              return _context3.a(2, {
                broadcast: false,
                reason: 'needs-manual',
                refund: row
              });
            case 8:
              return _context3.a(2, this.broadcastSaved(row));
          }
        }, _callee3, this);
      }));
      function _continue(_x2) {
        return _continue2.apply(this, arguments);
      }
      return _continue;
    }()
  }, {
    key: "signOnce",
    value: function () {
      var _signOnce = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(row, order) {
        var source, signed, tx, message, stored, current, _t6, _t7;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              source = order || this.orderFromRefund(row);
              _context4.p = 1;
              _context4.n = 2;
              return this.mod.createOrderRefundTransaction({
                order_row: source,
                refund_public_key: row.refund_publickey,
                reason: row.reason
              });
            case 2:
              tx = _context4.v;
              if (tx) {
                _context4.n = 3;
                break;
              }
              throw new Error('refund transaction was not created');
            case 3:
              _context4.n = 4;
              return tx.sign();
            case 4:
              signed = {
                signature: String(tx.signature || ''),
                serialized: typeof tx.serialize_to_web === 'function' ? tx.serialize_to_web(this.app) || '' : ''
              };
              _context4.n = 7;
              break;
            case 5:
              _context4.p = 5;
              _t6 = _context4.v;
              message = (_t6 === null || _t6 === void 0 ? void 0 : _t6.message) || String(_t6);
              if (!(this.expired(row) || /spent/i.test(message))) {
                _context4.n = 6;
                break;
              }
              return _context4.a(2, this.escalate(row, message));
            case 6:
              console.error('Store: refund transaction was not signed', {
                refund_id: row.id,
                payment_tx_sig: row.payment_tx_sig,
                error: message
              });
              return _context4.a(2, {
                broadcast: false,
                reason: 'sign-failed',
                error: _t6,
                refund: row
              });
            case 7:
              if (!(!signed.signature || !signed.serialized)) {
                _context4.n = 8;
                break;
              }
              return _context4.a(2, this.escalate(row, 'refund transaction has no signature or serialized form'));
            case 8:
              stored = false;
              _context4.p = 9;
              _context4.n = 10;
              return this.db.saveRefundTransactionIfEmpty(row.id, {
                signature: signed.signature,
                serialized: signed.serialized,
                preparedAt: Date.now()
              });
            case 10:
              stored = _context4.v;
              _context4.n = 12;
              break;
            case 11:
              _context4.p = 11;
              _t7 = _context4.v;
              console.error('Store: refund transaction was signed but not saved, so it was not broadcast', {
                refund_id: row.id,
                signature: signed.signature,
                error: (_t7 === null || _t7 === void 0 ? void 0 : _t7.message) || String(_t7)
              });
              return _context4.a(2, {
                broadcast: false,
                reason: 'save-failed',
                error: _t7,
                refund: row
              });
            case 12:
              _context4.n = 13;
              return this.db.returnRefundByPayment(row.payment_tx_sig, row.payment_output_index, row.block_hash_received);
            case 13:
              current = _context4.v;
              if (!stored && current !== null && current !== void 0 && current.refund_tx_sig && current.refund_tx_sig !== signed.signature) {
                console.error('Store: discarded an unsigned-for-broadcast refund that lost the claim', {
                  refund_id: row.id,
                  discarded_signature: signed.signature,
                  retained_signature: current.refund_tx_sig
                });
              }
              return _context4.a(2, current);
          }
        }, _callee4, this, [[9, 11], [1, 5]]);
      }));
      function signOnce(_x3, _x4) {
        return _signOnce.apply(this, arguments);
      }
      return signOnce;
    }()
  }, {
    key: "orderFromRefund",
    value: function orderFromRefund(row) {
      return {
        id: row.order_id,
        order_tx_sig: row.order_tx_sig,
        buyer: row.buyer,
        payment_tx_sig: row.payment_tx_sig,
        payment_output_index: row.payment_output_index,
        payment_amount: row.payment_amount,
        utxo_slip: row.utxo_slip,
        access_script: row.access_script,
        block_hash_received: row.block_hash_received,
        block_id_received: row.block_id_received
      };
    }
  }, {
    key: "broadcastSaved",
    value: function () {
      var _broadcastSaved = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(row) {
        var attempts, broadcastError, tx, status, current, _t8, _t9;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              if (!(!(row !== null && row !== void 0 && row.refund_tx) || !(row !== null && row !== void 0 && row.refund_tx_sig))) {
                _context5.n = 1;
                break;
              }
              return _context5.a(2, {
                broadcast: false,
                reason: 'missing-saved-transaction',
                refund: row
              });
            case 1:
              if (!this.expired(row)) {
                _context5.n = 2;
                break;
              }
              return _context5.a(2, this.escalate(row, 'refund retry window expired'));
            case 2:
              attempts = Number(row.refund_broadcast_attempts || 0) + 1;
              broadcastError = null;
              _context5.p = 3;
              tx = restoreTransaction(this.app, row.refund_tx);
              _context5.n = 4;
              return this.app.network.propagateTransaction(tx);
            case 4:
              _context5.n = 6;
              break;
            case 5:
              _context5.p = 5;
              _t8 = _context5.v;
              broadcastError = _t8;
            case 6:
              status = broadcastError ? 'uncertain' : 'submitted';
              _context5.p = 7;
              _context5.n = 8;
              return this.db.markRefundStatus(row.id, status, {
                error: broadcastError ? broadcastError.message || String(broadcastError) : '',
                attempts: attempts
              });
            case 8:
              _context5.n = 10;
              break;
            case 9:
              _context5.p = 9;
              _t9 = _context5.v;
              console.error('Store: refund status update failed after the saved transaction was kept', {
                refund_id: row.id,
                refund_tx_sig: row.refund_tx_sig,
                error: (_t9 === null || _t9 === void 0 ? void 0 : _t9.message) || String(_t9)
              });
            case 10:
              if (broadcastError) {
                console.error('Store: refund propagation failed; the saved transaction will be retried', {
                  refund_id: row.id,
                  refund_tx_sig: row.refund_tx_sig,
                  error: broadcastError.message || String(broadcastError)
                });
              }
              _context5.n = 11;
              return this.db.returnRefundBySignature(row.refund_tx_sig);
            case 11:
              current = _context5.v;
              return _context5.a(2, {
                broadcast: !broadcastError,
                confirmed: false,
                refund: current || _objectSpread(_objectSpread({}, row), {}, {
                  refund_status: status,
                  refund_broadcast_attempts: attempts
                })
              });
          }
        }, _callee5, this, [[7, 9], [3, 5]]);
      }));
      function broadcastSaved(_x5) {
        return _broadcastSaved.apply(this, arguments);
      }
      return broadcastSaved;
    }()
  }, {
    key: "escalate",
    value: function () {
      var _escalate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(row, error) {
        var message, current, _t0, _t1;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              message = String(error || 'refund requires manual intervention');
              _context6.p = 1;
              _context6.n = 2;
              return this.db.markRefundStatus(row.id, 'needs_manual', {
                error: message
              });
            case 2:
              _context6.n = 4;
              break;
            case 3:
              _context6.p = 3;
              _t0 = _context6.v;
              console.error('Store: could not record that a refund needs manual intervention', {
                refund_id: row.id,
                refund_tx_sig: row.refund_tx_sig || '',
                error: (_t0 === null || _t0 === void 0 ? void 0 : _t0.message) || String(_t0)
              });
            case 4:
              console.error('Store: refund requires manual intervention', {
                refund_id: row.id,
                refund_tx_sig: row.refund_tx_sig || '',
                payment_tx_sig: row.payment_tx_sig,
                payment_output_index: row.payment_output_index,
                block_hash_received: row.block_hash_received,
                error: message
              });
              _context6.n = 5;
              return this.db.returnRefundByPayment(row.payment_tx_sig, row.payment_output_index, row.block_hash_received);
            case 5:
              _t1 = _context6.v;
              if (_t1) {
                _context6.n = 6;
                break;
              }
              _t1 = row;
            case 6:
              current = _t1;
              return _context6.a(2, {
                broadcast: false,
                reason: 'needs-manual',
                refund: current
              });
          }
        }, _callee6, this, [[1, 3]]);
      }));
      function escalate(_x6, _x7) {
        return _escalate.apply(this, arguments);
      }
      return escalate;
    }()
  }, {
    key: "observeInclusion",
    value: function () {
      var _observeInclusion = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(blk, tx) {
        var _blk$id, _blk$hash;
        var signature, changes;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              signature = String((tx === null || tx === void 0 ? void 0 : tx.signature) || '');
              if (signature) {
                _context7.n = 1;
                break;
              }
              return _context7.a(2, null);
            case 1:
              _context7.n = 2;
              return this.db.recordRefundInclusion(signature, {
                block_id: Number((_blk$id = blk === null || blk === void 0 ? void 0 : blk.id) !== null && _blk$id !== void 0 ? _blk$id : 0),
                block_hash: String((_blk$hash = blk === null || blk === void 0 ? void 0 : blk.hash) !== null && _blk$hash !== void 0 ? _blk$hash : ''),
                transaction_id: transactionIndexInBlock(blk, tx)
              });
            case 2:
              changes = _context7.v;
              if (changes) {
                _context7.n = 3;
                break;
              }
              console.error('Store: included refund has no saved transaction', {
                refund_tx_sig: signature
              });
              return _context7.a(2, null);
            case 3:
              return _context7.a(2, this.db.returnRefundBySignature(signature));
          }
        }, _callee7, this);
      }));
      function observeInclusion(_x8, _x9) {
        return _observeInclusion.apply(this, arguments);
      }
      return observeInclusion;
    }()
  }]);
}();
module.exports = Refunds;